/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import * as modules from './modules';

Vue.use(Vuex);

export function createStore() {
  const store = new Vuex.Store({
    modules
  });

  return store;
}